import addCategorySopCategoriesPageImage from "../../../assets/images/add-category-sop/add-category-sop-categories-page.png";
import addCategorySopCategoryTreeImage from "../../../assets/images/add-category-sop/add-category-sop-category-tree.png";
import addCategorySopNewCategoryModalImage from "../../../assets/images/add-category-sop/add-category-sop-new-category-modal.png";
import addCategorySopParentCategoryImage from "../../../assets/images/add-category-sop/add-category-sop-parent-category.png";

import type { AddCategorySopImageConfig } from "../types";

export const ADD_CATEGORY_SOP_IMAGES: Record<
  string,
  AddCategorySopImageConfig
> = {
  "categories-page": {
    src: addCategorySopCategoriesPageImage,
    altKey: "add-category-sop-image-categories-page-alt",
    altFallback:
      "Categories page showing the category list and Add New Category button"
  },
  "new-category-modal": {
    src: addCategorySopNewCategoryModalImage,
    altKey: "add-category-sop-image-new-category-modal-alt",
    altFallback:
      "Add New Category window with fields for name, description, and parent category"
  },
  "parent-category": {
    src: addCategorySopParentCategoryImage,
    altKey: "add-category-sop-image-parent-category-alt",
    altFallback:
      "Parent Category list showing top-level and existing category options"
  },
  "category-tree": {
    src: addCategorySopCategoryTreeImage,
    altKey: "add-category-sop-image-category-tree-alt",
    altFallback:
      "Category list showing main categories and nested subcategories"
  }
};
